import React from "react";
import { useIntl } from "react-intl";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindText from "library/components/_tailwind/text";
import {
  hasMemberIntroContent,
  memberIntroDetailLines,
  memberIntroDisplayName,
} from "./format";
import { MemberIntroProfile } from "./types";

type Props = {
  intro: MemberIntroProfile | null;
  username?: string | null;
  showAbout?: boolean;
  showCountry?: boolean;
  align?: "left" | "center";
};

const MemberIntroSummary: React.FC<Props> = ({
  intro,
  username,
  showAbout = true,
  showCountry = true,
  align = "left",
}) => {
  const intl = useIntl();
  if (!intro || !hasMemberIntroContent(intro)) {
    return null;
  }

  const formatMessage = descriptor => intl.formatMessage(descriptor);
  const name = memberIntroDisplayName(intro, username);
  const detailLines = memberIntroDetailLines(intro, formatMessage);
  if (showCountry && intro.country) {
    detailLines[0] = detailLines[0]
      ? `${detailLines[0]} • ${intro.country}`
      : intro.country;
  }
  const textAlign = align === "center" ? "text-center" : "text-left";

  if (
    !name &&
    !detailLines.length &&
    !(showCountry && intro.country) &&
    !(showAbout && intro.about_me)
  ) {
    return null;
  }

  return (
    <TailwindFlex
      flexDirection='flex-col'
      alignItems={align === "center" ? "items-center" : "items-start"}
      width='w-full'>
      {name ? (
        <TailwindText
          fontWeight='font-bold'
          textColor='text-main-color'
          textAlign={textAlign}>
          {name}
        </TailwindText>
      ) : null}
      {detailLines.map((line, index) => (
        <TailwindText
          key={line}
          fontSize='text-sm'
          textColor='text-secondary-color'
          textAlign={textAlign}
          margin={name || index ? ["mt-1"] : []}>
          {line}
        </TailwindText>
      ))}
      {showAbout && intro.about_me ? (
        <TailwindText
          fontSize='text-sm'
          textColor='text-main-color'
          textAlign={textAlign}
          margin={["mt-2"]}
          width='w-full'
          style={{
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
          }}>
          {intro.about_me}
        </TailwindText>
      ) : null}
    </TailwindFlex>
  );
};

export default MemberIntroSummary;
